import { SET_AUTH } from "../actions";
import { AuthReducer, RoleOptions } from "../types/authTypes";

export const AUTH_REDUCER_INITIAL_STATE = {
  logged: null,
  role: null,
};

type AuthReducerProps = {
  type: string;
  payload: { logged?: boolean; role?: RoleOptions };
};

export default (
  state: AuthReducer = AUTH_REDUCER_INITIAL_STATE,
  { type, payload }: AuthReducerProps,
): AuthReducer => {
  switch (type) {
    case SET_AUTH:
      return { ...state, ...payload };
    default:
      return state;
  }
};
